import { render, staticRenderFns } from "./exchange-gift-add.vue?vue&type=template&id=7c9e3e4e"
import script from "./exchange-gift-add.vue?vue&type=script&lang=js"
export * from "./exchange-gift-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports